import { faTags } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Alert, Button, Dropdown } from "react-bootstrap";
import { Clink, ClinkResponseDto, CountryOption, MessageType, ResponseStatus } from "../../../utils/types";
import { Clinks } from "../../../services/Clinks";
import TagsAutocomplete from "../../TagsAutocomplete";
import Loading from "../../../utils/Loding";
import { Tags } from "../../../services/Tags";

interface ClinkTagsDropdownProps {
  clinkId: string;
  reloadClink: (clinkId:string, apply?:boolean) => void;
}

function ClinkTagsDropdown(props:ClinkTagsDropdownProps) {
  const { clinkId, reloadClink } = props;
  const [clinkResponseDto, setClinkResponseDto] = useState<ClinkResponseDto>(null);
  const [clink, setClink] = useState<Clink>(null);
  const [mostFrequentTags, setMostFrequentTags] = useState([]);
  const [error, setError] = useState("");
  const [dirty, setDirty] = useState<boolean>(false);
  const tagsRef = useRef(null);

  const handleToggle = (toogle:boolean) => {
    if (toogle && (!dirty || error)) {
      Clinks.getClink(clinkId, setClinkResponseDto);
    }
  }

  const handleTagsKeyDown = (e:any) => {
    if (e.code === "Tab" || e.code === "Enter" || e.code === "Space" || e.code === "Comma" || e.code === "NumpadEnter") {
      e.preventDefault();
      tagsRef.current.setState({...tagsRef.current.state, text: ""});
      const newTag = (e.target as HTMLInputElement).value;
      if (newTag.length) {
        const currentTags = clink.tags;
        if (currentTags.includes(newTag)) {
          currentTags.splice(currentTags.indexOf(newTag), 1);
        }
        setClink((prevClink:Clink) =>{
          return {
            ...prevClink,
            tags: [...prevClink.tags, newTag]
          };
        });
        setDirty(true);
      }
    }
  }

  const handleTagsChange = (value:any) => {
    setClink((prevClink:Clink) =>{
      return {
        ...prevClink,
        tags: value
      };
    });
    setDirty(true);
  }

  const handleUpdateTags = async () => {
    const updatedClink = clink;

    const updateParams = {
      method: "addClink",
      clinkid: updatedClink.clinkId,
      status: updatedClink.status,
      pubid: updatedClink.pubId,
      siteid: updatedClink.siteId,
      appid: updatedClink.appId,
      campids: [updatedClink.campaigns.map((c) => c.source + ':' + c.campaign_id)].join(","),
      platforms: updatedClink.platforms,
      ignorePlatforms: updatedClink.ignorePlatforms,
      p2p: updatedClink.p2p,
      minPayout: updatedClink.minPayout,
      countries: updatedClink.countries ? updatedClink.countries.map((country:CountryOption) => country.id).join(" ") : "",
      dailyCap: updatedClink.dailyCap,
      incent: updatedClink.incent,
      owner: updatedClink.owner,
      useRevShareP2P: updatedClink.useRevShareP2p,
      allowCounterBidOverride: updatedClink.allowCounterBidOverride,
      allowCounterBid: updatedClink.allowCounterBid,
      tags: updatedClink.tags ? updatedClink.tags.join(" ") : ""
    };
    const result:any = await Clinks.updateCLink(updateParams);
    if (!result.error) {
      setError("");
      setDirty(false);
      Clinks.getClink(clinkId, setClinkResponseDto);
      reloadClink(clinkId, true);
    } else {
      setError(result.error.message ? result.error.message : "Error");
    }
  }

  const tagsIcon = <FontAwesomeIcon icon={faTags} fixedWidth></FontAwesomeIcon>;

  useEffect(() => {
    if (clinkResponseDto && clinkResponseDto.clink) {
      setClink(clinkResponseDto.clink);
      Tags.getMostFrequentTags(setMostFrequentTags)
    }

    return () => setClink(null);
  }, [clinkResponseDto]);

  let clinkTagsElement;
  if (clinkResponseDto && clinkResponseDto.status === ResponseStatus.LOADING) {
    clinkTagsElement = <Loading />;
  } else if (clink) {
    clinkTagsElement = (
      <div style={{ margin: "10px", display: "flex" }}>
        <TagsAutocomplete
          onChange={(e:any) => handleTagsChange(e.map((tag:any) => tag.label ? tag.label : tag))}
          onKeyDown={(e) => handleTagsKeyDown(e)}
          options={mostFrequentTags}
          selected={clink.tags}
          reactRef={tagsRef}
          style={{ fontSize: "12px", width: "400px" }}
        />
        <Button
          variant="primary"
          size="sm"
          style={{ marginLeft: "10px", minWidth: "100px", fontSize: "12px" }}
          disabled={!dirty}
          onClick={handleUpdateTags}
        >
          Update
        </Button>
      </div>
    );
  }

  return (
    <Dropdown onToggle={handleToggle}>
      <Dropdown.Toggle
        style={{ fontSize: 12, borderRadius: 0 }}
        size="sm"
        variant="primary"
        className="dropdown-without-arrow"
      >
        {tagsIcon}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ minWidth: "520px" }}>
        {clinkTagsElement}
        {
          error && error.length > 0 ?
            <Alert variant={MessageType.DANGER}>{error}</Alert>
          : null
        }
      </Dropdown.Menu>
    </Dropdown>
  );
}
export default ClinkTagsDropdown;